import React from "react";
import "./Clients.css";
import clientsData from "../data/clients.json";

const ctx = require.context("../assets/clients", false, /\.(png|jpe?g|webp|svg)$/);
const fallbackLogo = "data:image/gif;base64,R0lGODlhAQABAAAAACw="; // transparent pixel

function resolveLogo(path) {
  if (!path) return fallbackLogo;
  if (/^https?:\/\//i.test(path)) return path;
  const cleaned = path
    .replace(/^src\//, "")
    .replace(/^assets\//, "")
    .replace(/^clients\//, "")
    .replace(/^\/*/, "");
  try {
    return ctx(`./${cleaned}`);
  } catch (err) {
    return fallbackLogo;
  }
}

function groupByCategory(list) {
  return list.reduce((acc, item) => {
    const category = item.category || "Other";
    if (!acc[category]) acc[category] = [];
    acc[category].push(item);
    return acc;
  }, {});
}

export default function Clients() {
  const normalized = clientsData.map((client) => ({
    ...client,
    image: resolveLogo(client.imageUrl),
  }));
  const grouped = groupByCategory(normalized);
  const categories = Object.keys(grouped).sort();

  return (
    <section className="clients-section">
      <div className="clients-shell container">
        <div className="clients-head">
          <span className="eyebrow">Trusted By</span>
          <h2>Leaders & Global Partners</h2>
          <p>
            We proudly supply precision instrumentation solutions to leading oil & gas, mining,
            and industrial companies across Australia and beyond.
          </p>
        </div>

        <div className="clients-groups">
          {categories.map((cat) => (
            <div
              key={cat}
              className={`clients-category ${grouped[cat].length >= 3 ? 'span-2' : ''}`}
            >
              <div className="category-header">
                <span className="category-pill">{cat}</span>
              </div>
              <div className="clients-mosaic">
                {grouped[cat]
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((client) => (
                    <div key={client.name} className="mosaic-card">
                      <div className="mosaic-logo">
                        <img
                          src={client.image}
                          alt={client.name}
                          loading="lazy"
                          onError={(e) => {
                            e.currentTarget.src = fallbackLogo;
                          }}
                        />
                      </div>
                      <div className="mosaic-meta">
                        <span className="mosaic-name">{client.name}</span>
                        {/* <span className="mosaic-cat">{client.category}</span> */}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}